module.exports = __webpack_public_path__ + "static/media/ic_download.8d502cb5.svg";